var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "mb-28px"
  }, [_c('v-row', {
    staticClass: "row-cols-md-5 my-n4px",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "my-4px"
  }, [_c('v-btn', {
    attrs: {
      "x-large": "",
      "block": "",
      "color": "".concat(_vm._category ? 'transparent' : 'primary')
    },
    on: {
      "click": function click($event) {
        return _vm.$router.push('/gshop/brand?page=1');
      }
    }
  }, [_c('span', {
    staticClass: "mr-4px mr-md-6px"
  }, [_c('v-img', {
    attrs: {
      "src": "".concat(_vm._category ? '/images/giftcard/all_b.png' : '/images/giftcard/all_w.png'),
      "alt": "all",
      "aspect-ratio": 25 / 26,
      "width": "26",
      "height": "25",
      "contain": ""
    }
  })], 1), _c('span', {
    staticClass: "font-size-14 font-size-lg-18"
  }, [_vm._v(" 전체 ")])])], 1), _vm._l(_vm.categories, function (category) {
    return _c('v-col', {
      key: category._id,
      staticClass: "my-4px"
    }, [_c('v-btn', {
      attrs: {
        "x-large": "",
        "block": "",
        "color": "".concat(_vm._category === category._id ? 'primary' : 'transparent')
      },
      on: {
        "click": function click($event) {
          return _vm.$router.push("/gshop/brand?_category=".concat(category === null || category === void 0 ? void 0 : category._id, "&page=1"));
        }
      }
    }, [_c('span', {
      staticClass: "mr-4px mr-lg-6px"
    }, [_c('v-img', {
      attrs: {
        "src": "".concat(_vm._category === category._id ? "https://daehanbooksgiftcard.com/".concat(category === null || category === void 0 ? void 0 : category.icon2) : "https://daehanbooksgiftcard.com/".concat(category === null || category === void 0 ? void 0 : category.icon)),
        "aspect-ratio": 25 / 26,
        "width": "26",
        "height": "25",
        "contain": ""
      }
    })], 1), _c('span', {
      staticClass: "font-size-14 font-size-lg-18"
    }, [_vm._v(" " + _vm._s(category === null || category === void 0 ? void 0 : category.name) + " ")])])], 1);
  })], 2)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }